import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import BaseMnTree from "@mnjsplatform/components/lib/common/BaseMnTree";
import i18next from "i18next";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";
import * as ea from "@mnjsplatform/data/lib/actions/errorActions";
import HttpQuery from "@mnjsplatform/data/lib/api/HttpQuery";
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'


class HelpViewer extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {txtValue: "", defaultKey: {a:0}};
    }

    async componentDidMount() {
        await this.props.dispatch(this.props.getHelpMembers.execute({}, {treeExpanded: false, withParams:false}));
        if (this.props.getHelpMembers.isError)
            return;

        if (this.props.getHelpMembers.rowsCount() === 0)
            return;

        await this.selectTreeRow(0, true);
    }

    selectTreeRow = async (i, expand) => {

        if (expand)
            await this.props.dispatch(this.props.getHelpMembers.treeOperation(i, true));

        const key = this.props.getHelpMembers.getRowKeyByIndex(i);
        await this.getChapters(key);
    }

    async getChapters(key) {
        this.setState({defaultKey:key});

        await this.props.dispatch(this.props.getList.execute(key));

        if (this.props.getList.rowsCount()>0)
        {
            await this.selectArticle(this.props.getList.getCurrentRowIndex())
        }
        else
            this.resetState();
    }

    selectArticle = async (i) => {
        const key = this.props.getList.getRowKeyByIndex(i);
        await this.props.dispatch(this.props.describe.execute(key));

        try {
            const val = await this.getBinaryFieldJson(this.props.getList.controllerName, this.props.describe.methodName, 0, "Bin");
            const txtData = val.value;
            this.setState({txtValue: txtData});
        }
        catch (e) {
            this.props.dispatch(ea.errorRaised(e));
        }
    }

    resetState = () => {
        this.setState({txtValue: ""});
    }

    getBinaryFieldJson(controllerName, methodName, rowIndex, fieldName = null, ) {
        let hq = new HttpQuery();
        return hq.makeApiCallPost(`${controllerName}/GetHelpData`, { methodName, rowIndex, fieldName});
    }

    render() {
        return (<>
            <div className="row">
                <div className="col-md-2" >
                <BaseMnTree dataItem={this.props.getHelpMembers} dispatch={this.props.dispatch} nodeRender={this.nodeRender} renderRow={this.renderRow} s = {this.state.defaultKey}/>
                </div>
                <div className="col-md-10">
                    <div className="row" >
                        <div className="font-weight-bold" >
                            {i18next.t("HelpTopic")}:
                        </div>
                        <div className="col-md-3" >
                            <MnComboStandalone ownItem={this.props.getList} valueFieldName="HelpPageName" onSelected={this.selectArticle} dropdownValueOnly />
                        </div>
                    </div>
                    <div className="row" >
                        <div className="col-md-12 p-3 help-container">
                            <ReactMarkdown rehypePlugins={[rehypeRaw, remarkGfm]}>{this.state.txtValue}</ReactMarkdown>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }

    renderRow = (rowData) => {

        let {treeData, row, rowIndex, label, collapse, expand} = rowData;


        let image = <span/>;

        let ctrl = ()=>{};

        let cursorType = "auto";

        const self = this;

        const isLeaf = treeData.IsLast || treeData.IsEmpty;
        const expandable = !treeData.IsExpanded && !isLeaf;
        const collapsable = treeData.IsExpanded && !isLeaf;

        if (expandable) {
            ctrl = function (e) {
                e.preventDefault();
                expand(rowIndex);
            };
            image = <i className="zmdi zmdi-chevron-right" style={{color: "#17b169"}} onClick={ctrl}/>;
            cursorType = "pointer";
        } else if (collapsable) {
            ctrl = function (e) {
                e.preventDefault();
                collapse(rowIndex);
            };
            image = <i className="zmdi zmdi-chevron-down" style={{color: "#17b169"}} onClick={ctrl}/>;
        }

        let backColor = "transparent";

        if (rowIndex === this.props.getHelpMembers.getRowIndex(this.state.defaultKey))
            backColor = "#DDDDDD";

        return (
            <div style={{
                marginLeft: treeData.Level * 20,
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: backColor
            }} key={row[this.props.keyFieldName]}>
                <label className={"lt-label"}
                       style={{cursor: cursorType, paddingLeft: "5px", paddingRight: "5px"}}>
                    {image} <span style={{cursor: "pointer"}} onClick={async ()=>await self.selectTreeRow(rowIndex,expandable)}>{label}</span>
                </label>
            </div>
        );
    }
}

HelpViewer.propTypes = {
    dispatch: PropTypes.func.isRequired
};


HelpViewer.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        getHelpMembers: state.helpState.getHelpMembers,
        getList: state.helpState.getList,
        describe: state.helpState.describe,
    };
}

export default connect(mapStateToProps)(HelpViewer)